import { render } from "./ParticularOrder.vue?vue&type=template&id=20c1b55a"
import script from "./ParticularOrder.vue?vue&type=script&lang=js"
export * from "./ParticularOrder.vue?vue&type=script&lang=js"

import "./ParticularOrder.vue?vue&type=style&index=0&id=20c1b55a&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__